export default "__VITE_ASSET__BTPiAHTg__"